import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {MatDialog} from '@angular/material/dialog';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {CategoryTableService} from './category-table.service';
import {CategoryEditorComponent} from '../../components/category-editor/category-editor.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {filter, switchMap} from 'rxjs';
import {MessageService} from '@lib-services/message.service';
import {CategoryService} from '@lib-services/category.service';

@Component({
    selector: 'app-category',
    standalone: true,
    imports: [CommonModule, CommonTableComponent, LoaderComponent, AdvancedSearchComponent],
    templateUrl: './category.component.html',
    styleUrl: './category.component.scss'
})
export class CategoryComponent {
    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН'},
            { name: 'name', title: 'Название работы' },
            { name: 'customId', title: 'CustomID' },
            { name: 'equipmentExTableName', title: 'Имя таблицы оборудования' },
            { name: 'companyName', title: 'Компания' },
        ],
        createButtonLabel: 'Добавить категорию',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'Название работы',
            name: 'name',
        },
        // {
        //     type: 'common-dropdown',
        //     label: 'Компания',
        //     name: 'company.id',
        //     commonDropdownConfig: {
        //         service: inject(CompanySelectorService),
        //         formCtrl: new FormControl(),
        //     },
        // },
    ];

    protected dialog = inject(MatDialog);
    protected categoryTableService = inject(CategoryTableService);
    protected categoryService = inject(CategoryService);
    protected messageService = inject(MessageService);

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ categoryId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deleteCategories(ids);
        }
    }

    openDialog(data: { categoryId?: number }): void  {
        this.dialog.open(CategoryEditorComponent, {
            width: '50%',
            height: '35%',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.categoryTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.categoryTableService.updateData(this.tableConfig);
    }

    deleteCategories(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление категории(й)',
            text: 'Вы действительно хотите удалить выбранные категории?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.categoryService.deleteCategories(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Категории успешно удалены');
                this.categoryTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }
}
